import { __spreadArray } from "tslib";
import { Util } from '@antv/g2';
var ORIGIN_MATRIX = [1, 0, 0, 0, 1, 0, 0, 0, 1];
/**
 * 矩阵变换
 * @param actions
 * @param matrix
 */
export function transform(actions, matrix) {
    var ulMatrix = matrix ? __spreadArray([], matrix, true) : __spreadArray([], ORIGIN_MATRIX, true);
    return Util.transform(ulMatrix, actions);
}
//# sourceMappingURL=matrix.js.map